import { ApplicationInsights } from '@microsoft/applicationinsights-web'

export const appInsights = new ApplicationInsights({
  config: {
    connectionString: import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING,
    enableAutoRouteTracking: true,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    correlationHeaderExcludedDomains: ['*.auth0.com', '*.hubspot.com']
  }
})
if (import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING) {
  appInsights.loadAppInsights()
  appInsights.trackPageView()
} else {
  console.info('Could not load VITE_APPINSIGHTS_CONNECTION_STRING from env')
}

export function getOperationId(): string | undefined {
  return appInsights.context?.telemetryTrace?.traceID
}

export function setAuthenticatedUser(userId: string, email?: string): void {
  appInsights.setAuthenticatedUserContext(userId, email, true)
}
